exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.screen-topbar h1 {\n  display: inline-block;\n  width: 240px;\n  margin: 0;\n  margin-left: -16px !important;\n  padding-left: 36px;\n}\n@media (min-width: 960px) {\n.screen-topbar h1 {\n    margin-left: -24px !important;\n}\n}\n", ""]);

// exports
